// Registers only the ECharts pieces the Insights charts use (keeps the bundle small).
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { LineChart, BarChart } from 'echarts/charts';
import { GridComponent, TooltipComponent } from 'echarts/components';

use([CanvasRenderer, LineChart, BarChart, GridComponent, TooltipComponent]);

// Line and bar marks use the darker teal (3:1+ on white); the light teal is only the area fill.
export const CHART_COLOR = '#008F84';
export const CHART_FILL = 'rgba(30, 190, 175, 0.35)';
export const CHART_GRID_COLOR = '#e5e7eb';
export const CHART_TEXT_COLOR = '#6b7280';


export type ValueFormatter = (value: number) => string;
